import { ISettingValidate } from './ReferralPersonalData.d';

const specialCharactersValidation = /^[a-zA-ZäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ\d\s]+$/;
const numbersValidation = /\d/;
const emailValidation = /^[\w-\.]+@([\w-]+\.)+[a-zA-Z]{2,3}$/;
const specialCharactersComments = /^[a-zA-Z\d\.,@\s]+$/;
const emailErrorMessage = 'El formato del email no es válido';

export const settingValidate: ISettingValidate = {
  name: {
    required: 'El nombre es requerido',
    validate: {
      specialCharacters: (value: string) => {
        const validation: boolean = specialCharactersValidation.test(value);
        return validation || 'El nombre no debe tener caracteres especiales, ejemplo: ¿¡<{[?!>]';
      },
      numbers: (value: string) => {
        const validation: boolean = numbersValidation.test(value);
        return !validation || 'El nombre no debe contener números';
      },
      doublespace: (value: string) => {
        const validation: boolean = value.includes('  ');
        return !validation || 'El nombre no debe tener más de un espacio entre palabras';
      },
    },
    maxLength: {
      value: 50,
      message: 'El nombre no debe tener más de 50 caracteres',
    },
  },
  surname: {
    required: 'El apellido es requerido',
    validate: {
      specialCharacters: (value: string) => {
        const validation: boolean = specialCharactersValidation.test(value);
        return validation || 'El apellido no debe tener caracteres especiales, ejemplo: ¿¡<{[?!>]';
      },
      numbers: (value: string) => {
        const validation: boolean = numbersValidation.test(value);
        return !validation || 'El apellido no debe contener números';
      },
      doublespace: (value: string) => {
        const validation: boolean = value.includes('  ');
        return !validation || 'El apellido no debe tener más de un espacio entre palabras';
      },
    },
    maxLength: {
      value: 50,
      message: 'El apellido no debe tener más de 50 caracteres',
    },
  },
  dni: {
    required: 'El documento es requerido',
    validate: {
      specialCharacters: (value: string) => {
        const validation: boolean = /^[a-zA-Z\d-]+$/.test(value);
        return validation || 'El documento solo puede tener números, letras y guiones';
      },
    },
    maxLength: {
      value: 15,
      message: 'El documento no debe tener más de 15 caracteres',
    },
    minLength: {
      value: 4,
      message: 'El documento debe tener más de 4 caracteres',
    },
  },
  email: {
    required: 'El email es requerido',
    validate: {
      emailStandar: (value: string) => {
        const validation: boolean = emailValidation.test(value);
        return validation || emailErrorMessage;
      },
      doubleAt: (value: string) => {
        const firstAt: number = value.indexOf('@');
        const lastAt: number = value.lastIndexOf('@');
        return firstAt === lastAt || emailErrorMessage;
      },
    },
    maxLength: {
      value: 80,
      message: emailErrorMessage,
    },
  },
  comments: {
    validate: {
      specialCharacters: (value: string) => {
        if (value) {
        const validation: boolean = specialCharactersComments.test(value);
        return validation || 'Comentarios solo debe tener caracteres especiales: .,@';
        } else {
          return true
        }
      },
    },
  }
};
